import React from "react";
import { useIntl } from "react-intl";
import { PeekButton, PeekStack, PeekTypography } from "@piiqtechnologies/ui-components";
import { HelpCircle } from "@piiqtechnologies/svg-icons";
import messages from "../messages.i18n";
export const NewReportHelpButton = ({ onClick }) => {
    const intl = useIntl();
    return (React.createElement(PeekButton, { onClick: onClick, sx: { width: "fit-content", marginLeft: -1, opacity: 0.7 } },
        React.createElement(PeekStack, { direction: "row", alignItems: "center", gap: 0.5 },
            React.createElement(PeekTypography, { variant: "h3", lineHeight: "10px" },
                React.createElement(HelpCircle, null)),
            React.createElement(PeekTypography, { variant: "h3" }, intl.formatMessage(messages.newReportLayoutHelp)))));
};
export default NewReportHelpButton;
